'use client'

import { themeBackgroundBlurMap, themeBackgroundMap } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { useSidebarLayoutContext } from './use-sidebar-layout.ts'

type SidebarLayoutFooterProps = Readonly<PropsWithChildren>

const SidebarLayoutFooter = ({ children }: SidebarLayoutFooterProps) => {
  const { clampWidthClassName } = useSidebarLayoutContext()

  return (
    <footer
      className={cn(
        'sticky bottom-0 mt-auto shadow-blur border-t border-white/10',
        themeBackgroundMap['container-secondary'],
        themeBackgroundBlurMap['blur-md']
      )}
    >
      <div
        className={cn(
          'p-6 mx-auto flex items-center h-full w-full',
          clampWidthClassName
        )}
      >
        {children}
      </div>
    </footer>
  )
}

export { SidebarLayoutFooter }
